module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.20687",
      "conversations-internal-schema": "static-1.9814",
      "head-dlb": "static-1.2040",
      "hs-test-utils": "static-1.5034",
      "hubspot-url-utils": "static-1.1682",
      "HubStyleTokens": "static-2.8583",
      "I18n": "static-7.1265",
      "jasmine-runner": "static-1.3436",
      "quartz": "static-1.3614",
      "react": "static-7.133",
      "sinon": "static-1.9",
      "webpack-env": "static-1.41",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.422",
      "enviro": "static-4.260",
      "hs-promise-rejection-tracking": "static-1.2371",
      "PortalIdParser": "static-2.239",
      "raven": "static-3.2477",
      "raven-hubspot": "static-1.2784",
      "bend-plugin-trellis-migration": "static-1.692",
      "moment": "static-3.26",
      "immutable": "static-2.19",
      "transmute": "static-2.29",
      "HeadJS": "static-2.495",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.3491",
      "foundations-theming": "static-1.1002",
      "framer-motion": "static-1.26",
      "hs-test-utils-bend-plugin": "static-1.145",
      "hub-http": "static-1.2732",
      "hub-http-janus": "static-1.562",
      "hub-http-rxjs": "static-1.527",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "react-utils": "static-2.2874",
      "redux": "static-4.16",
      "redux-mock-store": "static-1.8",
      "redux-thunk": "static-2.17",
      "testing-library": "static-1.109",
      "UIComponents": "static-3.5533",
      "i18n-data": "static-1.184",
      "metrics-js": "static-1.6542",
      "moment-timezone": "static-5.17",
      "jasmine": "static-4.1479",
      "browserslist-config-hubspot": "static-1.135",
      "quartz-core-utils": "static-1.481",
      "csstype": "static-1.8",
      "floating-ui": "static-1.16",
      "foundations-assets": "static-1.1898",
      "hs-story-utils": "static-1.5986",
      "react-aria": "static-1.28",
      "react-virtualized": "static-2.63",
      "styled-components": "static-2.40",
      "tanstack-table": "static-1.10",
      "ui-fonts": "static-1.326",
      "ui-images": "static-2.749",
      "rxjs": "static-5.10",
      "hoist-non-react-statics": "static-3.9",
      "classnames": "static-2.10",
      "cssUtils": "static-1.316",
      "HubStyle": "static-2.8893",
      "icons": "static-2.583",
      "react-select-plus": "static-1.65",
      "sassPrefix": "static-1.117",
      "react-input-autosize": "static-2.17"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.20687",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.9814",
      "head-dlb": "/head-dlb/static-1.2040",
      "hs-test-utils": "/hs-test-utils/static-1.5034",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.1682",
      "HubStyleTokens": "/HubStyleTokens/static-2.8583",
      "I18n": "/I18n/static-7.1265",
      "jasmine-runner": "/jasmine-runner/static-1.3436",
      "quartz": "/quartz/static-1.3614",
      "react": "/react/static-7.133",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.41",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.422",
      "enviro": "/enviro/static-4.260",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.2371",
      "PortalIdParser": "/PortalIdParser/static-2.239",
      "raven": "/raven/static-3.2477",
      "raven-hubspot": "/raven-hubspot/static-1.2784",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.692",
      "moment": "/moment/static-3.26",
      "immutable": "/immutable/static-2.19",
      "transmute": "/transmute/static-2.29",
      "HeadJS": "/HeadJS/static-2.495",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.3491",
      "foundations-theming": "/foundations-theming/static-1.1002",
      "framer-motion": "/framer-motion/static-1.26",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.145",
      "hub-http": "/hub-http/static-1.2732",
      "hub-http-janus": "/hub-http-janus/static-1.562",
      "hub-http-rxjs": "/hub-http-rxjs/static-1.527",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "react-utils": "/react-utils/static-2.2874",
      "redux": "/redux/static-4.16",
      "redux-mock-store": "/redux-mock-store/static-1.8",
      "redux-thunk": "/redux-thunk/static-2.17",
      "testing-library": "/testing-library/static-1.109",
      "UIComponents": "/UIComponents/static-3.5533",
      "i18n-data": "/i18n-data/static-1.184",
      "metrics-js": "/metrics-js/static-1.6542",
      "moment-timezone": "/moment-timezone/static-5.17",
      "jasmine": "/jasmine/static-4.1479",
      "browserslist-config-hubspot": "/browserslist-config-hubspot/static-1.135",
      "quartz-core-utils": "/quartz-core-utils/static-1.481",
      "csstype": "/csstype/static-1.8",
      "floating-ui": "/floating-ui/static-1.16",
      "foundations-assets": "/foundations-assets/static-1.1898",
      "hs-story-utils": "/hs-story-utils/static-1.5986",
      "react-aria": "/react-aria/static-1.28",
      "react-virtualized": "/react-virtualized/static-2.63",
      "styled-components": "/styled-components/static-2.40",
      "tanstack-table": "/tanstack-table/static-1.10",
      "ui-fonts": "/ui-fonts/static-1.326",
      "ui-images": "/ui-images/static-2.749",
      "rxjs": "/rxjs/static-5.10",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.316",
      "HubStyle": "/HubStyle/static-2.8893",
      "icons": "/icons/static-2.583",
      "react-select-plus": "/react-select-plus/static-1.65",
      "sassPrefix": "/sassPrefix/static-1.117",
      "react-input-autosize": "/react-input-autosize/static-2.17"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};